import React from "react";
import { Col } from "antd";
import Table from "components/data/Table";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";
import Typography from "components/common/Typography";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";
import useHasPermissions from "hooks/useHasPermissions";
import { Permission } from "@ticketingplatform/api/dist/__generated__/globalTypes";

import { useVenueColumns, useVenueList } from "./hooks";

const VenueList = () => {
  const { columns } = useVenueColumns();
  const { venues, loading, pagination, tableChangeHandler } = useVenueList();

  const canCreateVenue = useHasPermissions([Permission.VENUE_CREATE]);

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage defaultMessage="Venues" />
          </Typography.Title>
        </Col>
        {canCreateVenue && (
          <Col>
            <ButtonLink type="primary" block to={ROUTE_PATHS.VenuesCreate}>
              <FormattedMessage defaultMessage="Create new venue" />
            </ButtonLink>
          </Col>
        )}
      </Header>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={venues}
        loading={loading}
        onChange={tableChangeHandler}
        pagination={pagination}
      />
    </>
  );
};

export default VenueList;
